var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "info-hint", attrs: { id: _vm.rootId } },
    [
      _c(
        "button",
        {
          ref: "button",
          staticClass: "info-hint__button",
          attrs: { type: "button", "aria-label": _vm.text },
        },
        [_c("LucideIcon", { attrs: { name: "info", size: 14 } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          attrs: {
            target: () => _vm.$refs.button,
            container: _vm.rootId,
            triggers: "hover focus",
            placement: "top",
            boundary: "viewport",
            "custom-class": "info-hint__popover",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }